import React, { useEffect, useState } from "react";
import LiveSingleLotInfo from "../children/LiveSingleLotInfo";
import LiveBidingArea from "../children/LiveBidingArea";
import {
  calculateRemainingTime,
  formatTime,
} from "../../../../../helpers/helpers";
import LiveLotsStatus from "../children/LiveLotsStatus";
import { useDispatch, useSelector } from "react-redux";
import { getLivePaidEmdOffer } from "../../../../../redux/action/liveRoom";
import { useParams } from "react-router-dom";

function LiveLotsDetails({
  liveOfferData,
  singleAuctionData,
  index
}) {
  const { id } = useParams()
  const dispatch = useDispatch();
  const [endTimer, setEndTimer] = useState(false);
  const [startTimer, setStartTimer] = useState(true);
  const { profile } = useSelector((state) => state?.profileStore);
  const [bidderDetails, setBidderDetails] = useState([]);
  const [HighestBidder, setHighestBidder] = useState(false);


  useEffect(() => {
    const checkTimeRemaining = () => {
      const remaining = formatTime(
        calculateRemainingTime(liveOfferData?.offerSchedule?.endTimeAndDate)
      );
      if (remaining <= "00:00:00") {
        setEndTimer(true);
      } else if (remaining === "00:00:05" || remaining === "00:04:00" || remaining === "00:02:00") {
        dispatch(getLivePaidEmdOffer(id, profile?.organization));
      } else {
        setEndTimer(false);
      }
    };

    const intervalId = setInterval(checkTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [liveOfferData, dispatch, profile, id]);

  useEffect(() => {
    const checkTimeRemaining = () => {
      const startingTime = formatTime(
        calculateRemainingTime(liveOfferData?.offerSchedule?.startTimeAndDate)
      );
      if (startingTime <= "00:00:00") {
        setStartTimer(false);
      } else {
        setStartTimer(true);
      }
    };

    const intervalId = setInterval(checkTimeRemaining, 1000);
    return () => clearInterval(intervalId);
  }, [liveOfferData, dispatch, profile, id]);


  return (
    <>
      <div
        className="liveLots pin-top"
        style={{
          border: "1px solid black",
          borderRadius: "12px 0px 12px 12px",
        }}
      >
        <div className="valign-wrapper column justify-center gap-1"><p>{liveOfferData.offerNumber || index}</p>

        </div>
        <div
          style={{
            backgroundColor: liveOfferData?.requiresPCBCertificate ? "#e8f7f7" : "#fcf1ff",
            borderRadius: "12px 0px 12px 12px",
          }}
        >
          <div>
            <LiveSingleLotInfo liveOfferData={liveOfferData} bidderDetails={bidderDetails} auctionId={singleAuctionData?.auctionId} />
            <hr className="black" style={{ height: "0.5px" }} />
            <LiveBidingArea
              liveOfferData={liveOfferData}
              timeEnded={endTimer}
              startTimer={startTimer}
              setBidderDetails={setBidderDetails}
              index={index}
            />
          </div>
        </div>
        <LiveLotsStatus
          item={liveOfferData}
          singleAuctionData={singleAuctionData}
          setHighestBidder={setHighestBidder}
          HighestBidder={HighestBidder}
          auctionType={singleAuctionData?.auctionType}
        />
      </div>
    </>
  );
}

export default LiveLotsDetails;
